import { Box, Typography } from '@mui/material';

const InfoCard = ({
    color = 'info',
    icon,
    title,
    description,
    direction = 'left',
    small = false,
}) => {
    return (
        <Box
            lineHeight={1}
            p={direction === 'center' ? 2 : 0}
            textAlign={direction}
        >
            {icon}
            <Typography
                display='block'
                variant='5'
                fontWeight='bold'
                mt={direction === 'center' ? 1 : 2}
                mb={1.5}
            >
                {title}
            </Typography>
            <Typography
                display='block'
                variant={small ? 'button' : 'body2'}
                color={color}
                pr={direction === 'left' ? 6 : 0}
                pl={direction === 'right' ? 6 : 0}
            >
                {description}
            </Typography>
        </Box>
    );
};

export default InfoCard;
